import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import asyncComponent from "util/asyncComponent";

const Participants = ({ match }) => (
  <Switch>
    <Route path={`${match.url}`} component={asyncComponent(() => import('../../components/Participants/ParticipantTable'))} />
  </Switch>
);

export default Participants;
